import { render, staticRenderFns } from "./PenawaranClient.vue?vue&type=template&id=03f6087e&scoped=true"
import script from "./PenawaranClient.vue?vue&type=script&lang=js"
export * from "./PenawaranClient.vue?vue&type=script&lang=js"
import style0 from "./PenawaranClient.vue?vue&type=style&index=0&id=03f6087e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f6087e",
  null
  
)

export default component.exports